import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-mobile-step-two',
  templateUrl: './mobile-step-two.component.html',
  styleUrls: ['./mobile-step-two.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileStepTwoComponent {
  @Output()
  private requestPreviousStep = new EventEmitter<void>();

  emitRequestPreviousStep() {
    this.requestPreviousStep.emit();
  }
}
